import React from 'react';
import Banner from '../../components/Banner';
import Navbar from '../../components/Navbar';
import ReturnAnnual from '../../components/AnnualReturn/ReturnAnnual';

function AnnualReturn() {
    return (
        <div>
            <Banner />
            <Navbar />
            <ReturnAnnual/>
        </div>
    )
}

export default AnnualReturn